import Carousel from "../../../components/Carousel/Carousel";

const Hero = ({ isMobile, data }) => {
  return (
    <Carousel
      autoPlay
      infiniteLoop={true}
      showArrows={false}
      showStatus={false}
      showThumbs={false}
      interval={6000}
      className="relative bg-blue-850"
    >
      {data?.header?.map((item) => (
        <div
          className="relative pt-12 md:pt-0 bg-blue-850 bg-opacity-60"
          key={item._id}
        >
          <div className="absolute top-20 md:top-1/4 left-8 md:left-20 z-10 w-3/4 md:w-1/2 xl:w-2/5 grid grid-cols-4">
            <h3 className="bg-blue-850 bg-opacity-60 text-base md:text-xl xl:text-2xl text-white flex justify-center items-center">
              {item.title}
            </h3>
            <p className="text-left bg-blue-750 bg-opacity-40 text-white text-xs font-thin md:font-normal md:text-base xl:text-lg px-2 py-1 col-span-3">
              {item.description}
            </p>
          </div>

          <img
            className="-mt-20"
            src={isMobile ? item.imageMobile : item.imageDesktop}
            alt={item.title}
          />
        </div>
      ))}
    </Carousel>
  );
};

export default Hero;
